(() => {
  if (window.EgiftsNewsletterV1) return;
  window.EgiftsNewsletterV1 = true;
  const revealFeedback = () => {
    const formId = window.location.hash.slice(1);
    if (!formId.startsWith('EgiftsNewsletter-')) return;
    const form = document.getElementById(formId);
    const feedback = form?.querySelector('[data-egifts-newsletter-feedback]');
    if (!feedback) return;
    const menu = form.closest('header-drawer');
    const details = menu?.querySelector('details');
    const summary = details?.querySelector('summary');
    if (details && summary) {
      details.open = true;
      if (typeof menu.openMenuDrawer === 'function') menu.openMenuDrawer(summary);
      else { details.open = true; summary.setAttribute('aria-expanded', 'true'); }
    }
    feedback.focus({ preventScroll: true });
    feedback.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', revealFeedback);
  else revealFeedback();
  document.addEventListener('shopify:section:load', revealFeedback);
})();